import React from 'react';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import Skeleton from '../Skeleton';

const ImageComponent = styled('img')(({ theme }) => ({
	width: 'inherit',
	maxWidth: 'inherit',
	height: 'inherit',
	maxHeight: 'inherit',
	borderRadius: 'inherit'
}));

const Image = ({ src, fallback, onLoaded, ...props }) => {
	const [imageLoaded, setImageLoaded] = useState(false);

	const handleOnLoaded = !!onLoaded ? onLoaded : () => {};

	return (
		<>
			{!imageLoaded && !fallback && <Skeleton />}
			{!imageLoaded && !!fallback && <ImageComponent src={fallback} {...props} />}
			<ImageComponent
				src={src}
				sx={{ display: !imageLoaded ? 'none' : '' }}
				onLoad={() => {
					setImageLoaded(true);
					handleOnLoaded();
				}}
				{...props}
			/>
		</>
	);
};

export default Image;
